import MenuItem from "@/lib/printess/source_menu/menuItem"

export default class SourceMenu {
  static fromRaw(json) {
    const menuItems = JSON.parse(json).map((item) => MenuItem.fromRaw(item));

    return new SourceMenu(menuItems);
  }

  constructor(menuItems) {
    this.menuItems = menuItems;
  }

  whereCategory(category) {
    return this.menuItems.filter((item) => item.category === category);
  }
}
